export class DistributionBucket {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "label",
            "baseName": "label",
            "type": "string",
            "format": ""
        },
        {
            "name": "baseline",
            "baseName": "baseline",
            "type": "number",
            "format": "double"
        },
        {
            "name": "current",
            "baseName": "current",
            "type": "number",
            "format": "double"
        }
    ];
    static getAttributeTypeMap() {
        return DistributionBucket.attributeTypeMap;
    }
    constructor() {
    }
}
